<template>
  <d-modal v-if="showModal" size="lg">
    <d-modal-header :close="false">
      <d-modal-title>Creating New Category</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div>
        <div class="text-secondary text-uppercase mt-3 mb-1">Name</div>
        <d-input v-model="name" help="hi" :state="validName ? null: false" class="mb-2" />
        <small v-if="!validName">A name is required</small>

        <div class="text-secondary text-uppercase mt-3 mb-1">
          Description
        </div>
        <quill-editor
          ref="myQuillEditor"
          v-model="description"
          :options="quillOptions"
        />
        <div class="text-secondary text-uppercase mt-3 mb-1">
          Category Photo
        </div>
        <vue-dropzone
          :maxFiles="1"
          :options="dropzoneOptions"
          @success="handleUploadSuccess"
          duplicateCheck
        />
        <d-checkbox class="my-2" v-model="published">PUBLISHED</d-checkbox>
      </div>
      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose"
          >Cancel</d-button
        >
        <async-button
          @click="insertProductCategory"
          text="Save"
          loadingText="saving..."
          :loading="saving"
        />
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import OddWizard from "@/components/Wizard/Wizard.vue";
import OddWizardTab from "@/components/Wizard/Tab.vue";
import { quillEditor } from "vue-quill-editor";
import quillDefaultOptions from "@/utils/quillOptions";
import VueDropzone from "@/components/vue2-dropzone/components/vue-dropzone.vue";

export default {
  data() {
    return {
      name: "",
      description: "",
      published: false,
      uploadResponse: null,
      id: null,
      image_pk: "",
      quillOptions: quillDefaultOptions,
      saving: false,
      validName: true,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dropzoneOptions() {
      return {
        thumbnailWidth: 150,
        maxFilesize: 0.5,
      };
    },
  },
  components: {
    OddWizard,
    OddWizardTab,
    quillEditor,
    VueDropzone,
  },
  watch: {
    showModal() {
      this.resetForm();
    },
  },
  methods: {
    resetForm() {
      this.name = "";
      this.description = "";
      this.published = false;
      this.image_pk = "";
      this.saving = false;
    },
    onEditorChange({ quill, html, text }) {
      this.description = html;
    },
    handleClose(event) {
      this.$emit("close", event);
    },
    validateName() {
      this.validName = (3 < this.name.length && this.name.length < 100);
    },
    handleUploadSuccess(file, response) {
      this.image_pk = response["pk"];
    },
    validate() {
      this.validateName();
      return this.validName;
    },
    insertProductCategory() {
      if (this.validate()) {
        this.saving = true;
        const productCategory = {
          name: this.name,
          description: this.description,
          enabled: this.published,
          header_image: this.image_pk,
        };
        this.$store
          .dispatch("productCategories/insert", productCategory)
          .then((result) => {
            this.saving = false;
            this.$emit('dataUpdated');
            this.handleClose();
          });
      }
    },
  },
};
</script>

<style></style>
